import { render, staticRenderFns } from "./BasePwdPayModify.vue?vue&type=template&id=3820abf2&scoped=true&"
import script from "./BasePwdPayModify.vue?vue&type=script&lang=js&"
export * from "./BasePwdPayModify.vue?vue&type=script&lang=js&"
import style0 from "./BasePwdPayModify.vue?vue&type=style&index=0&id=3820abf2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3820abf2",
  null
  
)

export default component.exports